import React, { useState } from "react";
import { Box, Button, TextField, CircularProgress, Modal } from "@mui/material";
import JohariPenceresi from "./JohariPenceresi"; // Import JohariPenceresi component
import { IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close"; // Ensure this import is present
import axios from 'axios'; // Import axios for making API calls

const OgrenciKayitGetir = () => {
  const [openModal, setOpenModal] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false); // New loading state for buttons
  const [testResults, setTestResults] = useState([]); // State to store fetched test results
  const [username, setUsername] = useState(''); // State to store the username input

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleGetRecords = async () => {
    setLoadingButton(true);
    try {
      const response = await axios.post('http://localhost:5001/api/v1/participant/test-results', {
        egt_kullanici_kod: username
      });
      setTestResults(response.data);
    } catch (error) {
      console.error('Error fetching test results:', error);
    } finally {
      setLoadingButton(false);
    }
  };

  const scores = {
  
  };

  return (
    <Box>
      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        <TextField
          label="Kursiyer Kullanıcı Adı"
          variant="outlined"
          size="small"
          sx={{ borderRadius: "10px" }}
          value={username}
          onChange={(e) => setUsername(e.target.value)} // Update username state on input change
        />
        <Button
          variant="contained"
          color="primary"
          sx={{ borderRadius: "10px" }}
          onClick={handleGetRecords}
        >
          {loadingButton ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Test Sonuçlarını Getir"
          )}
        </Button>
      </Box>
      <Box sx={{ width: "100%", margin: "left" }}>
        <DataGrid
          rows={testResults.map((result, index) => ({
            id: index + 1,
            atananTestler: result.egt_test_kod,
            tamamlanmaDurumu: result.egt_tamamlanma_durum ? "Tamamlandı" : "Devam Ediyor",
            sonuc: result.egt_test_sonuc,
            rapor: "",
          }))}
          columns={[
            { field: "atananTestler", headerName: "Atanan Testler", flex: 1 },
            {
              field: "tamamlanmaDurumu",
              headerName: "Tamamlanma Durumu",
              flex: 1,
            },
            { field: "sonuc", headerName: "Sonuç", type: "number", flex: 1 },
            {
              field: "rapor",
              headerName: "Rapor",
              flex: 1,
              renderCell: (params) => (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleOpenModal(params.row)}
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "white",
                    borderRadius: "10px", // Rounded corners
                    "&:hover": {
                      backgroundColor: "#115293",
                      transform: "scale(1.001)", // Subtle hover effect
                    },
                  }}
                >
                  Rapor
                </Button>
              ),
            },
          ]}
          autoHeight
          disableSelectionOnClick
        />
      </Box>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: "800px",
            maxHeight: "90vh",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <JohariPenceresi scores={scores} />
        </Box>
      </Modal>
    </Box>
  );
};

export default OgrenciKayitGetir;